import Swal from 'sweetalert2/dist/sweetalert2.js';

/**
 * Elegant confirmation dialog component
 * @param {Object} options Configuration options
 * @param {string} options.title Dialog title
 * @param {string} options.message Confirmation message
 * @param {string} options.confirmText Text for confirm button
 * @param {string} options.cancelText Text for cancel button
 * @param {string} options.t Translation function (optional)
 * @returns {Promise} Promise that resolves with the result
 */
const showConfirmationDialog = async ({
  title,
  message,
  confirmText,
  cancelText,
  size = 'medium',
  t = text => text // Default simple pass-through if no translation function provided
}) => {
  // Determine popup width based on size
  const getPopupWidth = () => {
    switch (size) {
      case 'small': return '90%';
      case 'large': return '90%';
      default: return '90%';
    }
  };

  const result = await Swal.fire({
    title: false, // No title
    html: `
            <div class="confirmation-content">
                <div class="confirmation-message">${message}</div>
            </div>
        `,
    showCancelButton: true,
    confirmButtonText: confirmText || t('Tamam'),
    cancelButtonText: cancelText || t('İptal'),
    showClass: {
      //  popup: 'animate__animated animate__fadeIn animate__faster'
    },
    hideClass: {
      //      popup: 'animate__animated animate__fadeOut animate__faster'
    },
    customClass: {
      container: 'elegant-confirmation-container',
      popup: 'elegant-confirmation-popup',
      htmlContainer: 'elegant-confirmation-content',
      confirmButton: 'elegant-confirmation-confirm',
      cancelButton: 'elegant-confirmation-cancel',
      actions: 'elegant-confirmation-actions'
    },
    buttonsStyling: false,
    width: 'auto',
    maxWidth: 450,
    background: '#ffffff',
    backdrop: 'rgba(0,0,0,0.4)',
    focusConfirm: true,
    allowOutsideClick: false,
    allowEscapeKey: true
  });

  return result.isConfirmed;
};

// Apply custom styles for the confirmation dialog
const applyCustomStyles = () => {
  const style = document.createElement('style');
  style.id = 'elegant-confirmation-styles';

  // Only append styles once
  if (!document.getElementById('elegant-confirmation-styles')) {
    style.innerHTML = `
      .elegant-confirmation-popup {
        border-radius: 6px;
        padding: 1.5rem;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        max-width: 450px;
        margin: 0 auto;
      }
      .elegant-confirmation-content {
        padding: 0px !important;
      }
      .confirmation-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 !important;
      }
      .confirmation-message {
        font-size: 1.05rem;
        line-height: 1.5;
        color: #333;
        text-align: center;
        padding: 0.25rem 0;
      }
      .confirmation-message b {
        color: #333;
        font-weight: 600;
      }
      .elegant-confirmation-actions {
        margin-top: 1.25rem;
        display: flex;
        justify-content: center;
        gap: 0.75rem;
      }
      .elegant-confirmation-confirm, 
      .elegant-confirmation-cancel {
        min-width: 100px;
        padding: 8px 16px;
        border-radius: 4px;
        font-size: 0.95rem;
        font-weight: 500;
        transition: background-color 0.2s ease;
        outline: none;
        border: none;
      }
      .elegant-confirmation-confirm {
        background-color: #dc3545;
        color: white;
      }
      .elegant-confirmation-confirm:hover, .elegant-confirmation-confirm:focus {
        background-color: #c82333;
      }
      .elegant-confirmation-cancel {
        background-color: #f8f9fa;
        color: #212529;
        border: 1px solid #dee2e6;
      }
      .elegant-confirmation-cancel:hover, .elegant-confirmation-cancel:focus {
        background-color: #e2e6ea;
      }
      
      /* Mobile optimizations */
      @media (max-width: 576px) {
        .elegant-confirmation-popup {
          padding: 1.25rem;
          width: 90% !important;
          margin: 0 auto;
        }
        
        .confirmation-message {
          font-size: 1rem;
        }
        
        .elegant-confirmation-actions {
          flex-direction: column-reverse;
          gap: 0.5rem;
          width: 100%;
        }
        
        .elegant-confirmation-confirm, 
        .elegant-confirmation-cancel {
          width: 100%;
          padding: 10px;
        }
      }
    `;
    document.head.appendChild(style);
  }
};

// Apply styles when this module is imported
applyCustomStyles();

export default showConfirmationDialog; 